// hooks/useFilterReset.js
import { useCallback } from "react";

export const useFilterReset = ({
  setSearchValue,
  setDebouncedSearchValue,
  setSelectedStatus,
  setSelectedDistrictId,
  setSelectedBlockId,
  setSelectedSubCategoryId,
  setSelectedCategory,
  setPerPage, // ✅ NEW
  setCurrentPage,
  fetchFunction,
  setSelectedYear,
  setSelectedSportId,
   fetchArgs = [],

}) => {
  return useCallback(() => {
    setSearchValue("");
    setDebouncedSearchValue && setDebouncedSearchValue("");
    if (setSelectedStatus) setSelectedStatus(0);
    if (setSelectedYear) setSelectedYear("");
    setSelectedDistrictId("");
    if (setSelectedBlockId) setSelectedBlockId("");
    setSelectedSubCategoryId("");
    setSelectedCategory("");
    setPerPage(10); // ✅ reset perPage to 10
    setCurrentPage(1);
    setSelectedSportId("");
    // fetchFunction(10, 1, 0, "", "", "");
    if (fetchFunction) {
      fetchFunction(...fetchArgs);
    }
  }, [
    setSearchValue,
    setDebouncedSearchValue,
    setSelectedStatus,
    setSelectedDistrictId,
    setSelectedBlockId,
    setSelectedSubCategoryId,
    setSelectedCategory,
    setPerPage, // ✅ dependency
    setCurrentPage,
    setSelectedYear,
    fetchFunction,
    setSelectedSportId,
    fetchArgs
  ]);
};


